import { createFileRoute } from "@tanstack/react-router";

import { StockPage } from "../../../features/inventory/stock-page";

export const Route = createFileRoute("/_app/inventory/stock")({ component: StockPage });
